import styled from 'styled-components'

export const Container = styled.section`
  width: 100%;
  height: 800px;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0;
  background-color: ${(props) => props.theme.azulEscuro};
  overflow: hidden; /* Esconde qualquer coisa que ultrapasse os limites do container, importante para o efeito de escala dos vídeos */
  /* Esconde qualquer coisa que ultrapasse os limites do container, importante para o efeito de escala dos vídeos */
  /* O overflow escondido impede que o efeito de escala vaze para as laterais */

  .swiper {
    overflow: visible; /* Permite que os vídeos em destaque "vazem" para fora do container */
    width: 100%;
    max-width: 1100px; /* Limita a largura total para não colar na borda da tela */
    margin: 0 auto;
    padding: 40px 0; /* Espaço para o efeito de escala (hover) não ser cortado */
  }

  .swiper-slide {
    display: flex;
    align-items: center; /* Centraliza os cards verticalmente entre si */
    justify-content: center; /* Centraliza horizontalmente */
    transition: all 0.5s ease;
    opacity: 0.4; /* Deixa os vídeos do lado bem apagadinhos */
    transform: scale(0.7); /* Diminui o tamanho dos laterais */
  }

  .swiper-slide-active {
    opacity: 1;
    transform: scale(1.2); /* Dá um leve "zoom" no vídeo em foco */
    z-index: 1; /* Garante que ele fique por cima de tudo */
  }

  h4 {
    color: ${(props) => props.theme.azulClaro};
  }
`

export const TituloSecao = styled.h2`
  text-align: center;
  color: ${(props) => props.theme.azulMuitoClaro};
  margin-bottom: 40px;
  font-size: 32px;
`

export const VideoCard = styled.div`
  max-width: 280px;
  background: ${(props) => props.theme.azulPrincipal};
  border-radius: 20px;
  padding: 10px;
  border: 1px solid ${(props) => props.theme.azulDestaque};
  width: 100%;
  height: auto;
  transition: all 0.3s ease;
  overflow: hidden; /* Esconde qualquer coisa que ultrapasse os limites do card */

  &:hover {
    transform: scale(
      1.05
    ); /* Agora ele tem espaço para crescer dentro do padding */
    border-color: ${(props) => props.theme.azulAcentuado};
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.4);
  }

  .video {
    width: 100%;
    height: auto;
    object-fit: cover;
  }

  .video-placeholder {
    aspect-ratio: 9 / 16;
    background: #000;
    border-radius: 20px;
  }
`

export const Video = styled.video`
  max-width: 300px;
  max-height: 500px;
  border-radius: 12px;
`
